<div class="ks-toast-stack" aria-live="polite" aria-atomic="true">
  @for (toast of toastService.toasts(); track toast) {
    <ngb-toast
      #t="ngbToast"
      [class]="toast.classname ?? 'ks-toast--info'"
      [autohide]="true"
      [delay]="toast.delay ?? 5000"
      (hidden)="remove(toast)">
      @if (toast.header) {
        <div class="ks-toast__row">
          <strong class="ks-toast__title">{{ toast.header }}</strong>
          <button
            type="button"
            class="ks-toast__close"
            aria-label="Cerrar notificación"
            (click)="t.hide()">
            <i class="bi bi-x-lg" aria-hidden="true"></i>
          </button>
        </div>
      }
      <div class="ks-toast__message">{{ toast.body }}</div>
    </ngb-toast>
  }
</div>
